import { render } from "./BaseSwitcher.vue?vue&type=template&id=2578ecb4&scoped=true"
import script from "./BaseSwitcher.vue?vue&type=script&lang=js"
export * from "./BaseSwitcher.vue?vue&type=script&lang=js"

import "./BaseSwitcher.vue?vue&type=style&index=0&id=2578ecb4&scoped=true&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2578ecb4"]])

export default __exports__